'use client';

import * as React from 'react';
import { CreateTranslationModalContent } from '@/app/dashboard/settings/translation/components/create-translation-modal-content';
import { useAppSelector } from '@/store/hooks';
import { getUi } from '@/store/reducers/ui-slice';

import { ModalDrawer } from '@/types/general';

import { ModalLayout } from '../core/modal-layout';

export function CreateTranslationModal(): React.JSX.Element {
  const { modal } = useAppSelector(getUi);

  return (
    <ModalLayout title="Add Translation" isOpen={modal?.open === ModalDrawer.CREATE_TRANSLATION}>
      <CreateTranslationModalContent />
    </ModalLayout>
  );
}
